'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useEffect } from 'react';
import { ApplePrompt } from './components/apple-prompt/apple-prompt';
import { WebPrompt } from './components/web-prompt/web-prompt';
import { useAppleInstallPrompt } from './hooks/use-apple-install-prompt';
import { useWebInstallPrompt } from './hooks/use-web-install-prompt';
import styles from './install-pwa-prompt.module.scss';
type InstallPWAPromptProps = {
  appleCancelLabel: string;
  canShow?: boolean;
  closeLabel: string;
  iosAddHomeInstructionsLabel: string;
  iosBodyLabel: string;
  iosShareInstructionsLabel: string;
  iosTitleLabel: string;
  onActiveChange?: (isActive: boolean) => void;
  safariAddHomeInstructionsLabel: string;
  safariBodyLabel: string;
  safariShareInstructionsLabel: string;
  safariTitleLabel: string;
  webBodyLabel: string;
  webInstallBtnLabel: string;
  webLogo: ReactNode;
};
export const InstallPWAPrompt = t0 => {
  const $ = _c(28);
  const {
    appleCancelLabel,
    canShow: t1,
    closeLabel,
    iosAddHomeInstructionsLabel,
    iosBodyLabel,
    iosShareInstructionsLabel,
    iosTitleLabel,
    onActiveChange,
    safariAddHomeInstructionsLabel,
    safariBodyLabel,
    safariShareInstructionsLabel,
    safariTitleLabel,
    webBodyLabel,
    webInstallBtnLabel,
    webLogo
  } = t0;
  const canShow = t1 === undefined ? true : t1;
  const [isApple, handleIOSInstallDeclined] = useAppleInstallPrompt();
  const [webInstallPrompt, handleWebInstallDeclined, handleWebInstallAccepted] = useWebInstallPrompt();
  const isAppleVisible = isApple && canShow;
  const isWebVisible = Boolean(webInstallPrompt) && canShow;
  let t2;
  let t3;
  if ($[0] !== isAppleVisible || $[1] !== isWebVisible || $[2] !== onActiveChange) {
    t2 = () => {
      onActiveChange?.(isAppleVisible || isWebVisible);
    };
    t3 = [isAppleVisible, isWebVisible, onActiveChange];
    $[0] = isAppleVisible;
    $[1] = isWebVisible;
    $[2] = onActiveChange;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== appleCancelLabel || $[6] !== handleIOSInstallDeclined || $[7] !== iosAddHomeInstructionsLabel || $[8] !== iosBodyLabel || $[9] !== iosShareInstructionsLabel || $[10] !== iosTitleLabel || $[11] !== isAppleVisible || $[12] !== safariAddHomeInstructionsLabel || $[13] !== safariBodyLabel || $[14] !== safariShareInstructionsLabel || $[15] !== safariTitleLabel) {
    t4 = isAppleVisible && <ApplePrompt addHomeInstructionsLabelIos={iosAddHomeInstructionsLabel} addHomeInstructionsLabelSafari={safariAddHomeInstructionsLabel} bodyLabelIos={iosBodyLabel} bodyLabelSafari={safariBodyLabel} cancelLabel={appleCancelLabel} onClose={handleIOSInstallDeclined} shareInstructionsLabelIos={iosShareInstructionsLabel} shareInstructionsLabelSafari={safariShareInstructionsLabel} titleLabelIos={iosTitleLabel} titleLabelSafari={safariTitleLabel} />;
    $[5] = appleCancelLabel;
    $[6] = handleIOSInstallDeclined;
    $[7] = iosAddHomeInstructionsLabel;
    $[8] = iosBodyLabel;
    $[9] = iosShareInstructionsLabel;
    $[10] = iosTitleLabel;
    $[11] = isAppleVisible;
    $[12] = safariAddHomeInstructionsLabel;
    $[13] = safariBodyLabel;
    $[14] = safariShareInstructionsLabel;
    $[15] = safariTitleLabel;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== closeLabel || $[18] !== handleWebInstallAccepted || $[19] !== handleWebInstallDeclined || $[20] !== isWebVisible || $[21] !== webBodyLabel || $[22] !== webInstallBtnLabel || $[23] !== webLogo) {
    t5 = isWebVisible && <WebPrompt bodyLabel={webBodyLabel} closeLabel={closeLabel} installBtnLabel={webInstallBtnLabel} logo={webLogo} onAccept={handleWebInstallAccepted} onClose={handleWebInstallDeclined} />;
    $[17] = closeLabel;
    $[18] = handleWebInstallAccepted;
    $[19] = handleWebInstallDeclined;
    $[20] = isWebVisible;
    $[21] = webBodyLabel;
    $[22] = webInstallBtnLabel;
    $[23] = webLogo;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  let t6;
  if ($[25] !== t4 || $[26] !== t5) {
    t6 = <div className={styles.wrapper}>{t4}{t5}</div>;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
  } else {
    t6 = $[27];
  }
  return t6;
};